import $ from 'jquery';

$(document).ready(function() {

    $('.services-expertise-row .elementor-column.default-service-hover').mouseenter( function() {

        $(this).removeClass('default-gradient-hover');

    });

    $('.services-expertise-row .elementor-column').mouseenter( function() {

      if (!$(this).hasClass('default-service-hover')) {

        console.log('x');

        $('.services-expertise-row .elementor-column.default-service-hover').removeClass('default-gradient-hover');

      }

  });

});

const myNav = $('.main-menubar-inner-section');

$(window).on('scroll', function() {

  if ($(window).scrollTop() >= 80) {
    myNav.addClass("scrolled");
  } else {
    myNav.removeClass("scrolled");
  }
});